// extracted by mini-css-extract-plugin
export default {"filterItemContainer":"SearchDropdown_filterItemContainer__s-AwM","filterType":"SearchDropdown_filterType__TR2Z9","closeIcon":"SearchDropdown_closeIcon__YTMrH"};